import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Input from '../../helper/form/input';
import { Row, Col, Button } from 'antd';

export class UserFormPassword extends Component {

    constructor(props) {
        super(props);

        this.state = {
            newPasword: '',
            newPasword_is_valid: false,
            validationNewPassword: '',
            validationNewPassword_is_valid: false
        }
    }


    send() {
        if (this.state.newPasword_is_valid && this.state.validationNewPassword_is_valid)
            this.props.actions.setUser({ password: this.state.newPasword, passwordConfirmation: this.state.validationNewPassword })
                .then(() => this.setState({
                    newPasword: '',
                    newPasword_is_valid: false,
                    validationNewPassword: '',
                    validationNewPassword_is_valid: false
                }))

        if (this.props.onSend) {
            this.props.onSend();
        }
    }

    render() {
        return (
            <Row>
                <Col xs={{ span: 23, offset: 1 }}>
                    <Col className="form-front" style={{ margin: '30px 0' }} xs={{ span: 24, offset: 1 }} >
                        <Col xs={{ span: 24 }} md={{ span: 12, offset: 6 }} lg={{ span: 12, offset: 6 }}>
                            <Input.Password
                                value={this.state.newPasword}
                                icon="lock"
                                placeholder="Nouveau mot de passe"
                                onCheck={(newPasword_is_valid) => this.setState({ newPasword_is_valid })}
                                onChange={(newPasword) => this.setState({ newPasword })}
                                checkOnChange
                                notEmpty
                            />
                            <Input.Password
                                value={this.state.validationNewPassword}
                                icon="lock"
                                placeholder="Confirmation nouveau mot de passe"
                                setStatus={this.state.validationNewPassword === this.state.newPasword ? 'success' : 'error'}
                                onCheck={(validationNewPassword_is_valid) => this.setState({ validationNewPassword_is_valid })}
                                onChange={(validationNewPassword) => this.setState({ validationNewPassword })}
                                isValid={(valueValidationNewPassword) => valueValidationNewPassword === this.state.newPasword}
                                status={{ success: '', error: 'Le mot de passe doit être identique' }}
                                checkOnChange
                                showSuccess
                                notEmpty
                            />
                        </Col>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12, offset: 6 }} lg={{ span: 12, offset: 6 }}>
                        <Button
                            onClick={() => this.send()}
                            className="ui-btn"
                            disabled={!this.state.newPasword_is_valid
                                && !this.state.validationNewPassword_is_valid
                                && this.state.validationNewPassword === this.state.newPasword}
                            style={{ width: '100%' }}
                        >
                            MODIFIER LE MOT DE PASSE
                    </Button>
                    </Col>
                </Col>
            </Row>
        );
    }

}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserFormPassword);


// WEBPACK FOOTER //
// ./src/features/user/UserFormPassword.js